import React, { FC, useEffect, useRef, useState } from 'react'
import AccountLinksDropDown from './AccountLinksDropDown'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'
import { useSelector } from 'react-redux'
import { getIsMobileScreenWidth } from 'selectors/screen'
import { getUserInitials } from 'selectors/user/session'

const Account: FC = () => {
  const userInitials = useSelector(getUserInitials)
  const isMobileScreenWidth = useSelector(getIsMobileScreenWidth)
  const { setMobileHeaderConfig } = useHeaderContext()
  const [dropdownIsOpen, handleDropdownOpen] = useState<boolean>(false)
  const [dropdownIsHovered, setDropdownIsHovered] = useState<boolean>(false)
  const accountRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    handleDropdownOpen((prevState) => !prevState)
    setDropdownIsHovered(false)
    if (isMobileScreenWidth) {
      setMobileHeaderConfig((previousMobileHeaderConfig) => ({
        ...previousMobileHeaderConfig,
        mobileMenuContent: 'user',
        mobileTopHeader: 'user',
        isMobileMenuOpen: true,
      }))
    }
  }

  const handleDropdownHovered = (booleanFlag) => {
    return () => {
      if (!isMobileScreenWidth) {
        setDropdownIsHovered(booleanFlag)
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        handleDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={styles.accountDropDownMenu}
      onMouseOver={handleDropdownHovered(true)}
      onMouseLeave={handleDropdownHovered(false)}
      onFocus={handleDropdownHovered(true)}
      onBlur={handleDropdownHovered(false)}
      data-type='account-icon'
      ref={accountRef}
    >
      <button
        type='button'
        aria-label='authentication links'
        className={classNames(styles.accountIcon, {
          [styles.accountIconMobile]: isMobileScreenWidth,
        })}
        onClick={handleClick}
        data-type={`account-initials${isMobileScreenWidth ? '-mobile' : ''}`}
      >
        <span className={styles.accountIconInitials}>{userInitials}</span>
      </button>
      <AccountLinksDropDown dropdownIsOpen={dropdownIsOpen} dropdownIsHovered={dropdownIsHovered} />
    </div>
  )
}

export default Account
